import React, { useEffect, useState } from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import FormLabel from 'react-bootstrap/FormLabel'
import Modal from 'react-bootstrap/Modal'
import Alert from 'react-bootstrap/Alert'
import Button from 'react-bootstrap/Button'
import FileUpload from 'components/FileUpload/FileUpload'
import { isEmpty } from 'utils/isEmpty'

function EditarSlide(props) {
	const { mostrar, slide, parteId, indicaciones, editar, cerrar, estructura } = props
	const [saveEnabled, setSaveEnabled] = useState(false)
	const [slideEditado, setSlideEditado] = useState([])

	const slideValido = slide && Array.isArray(slide) && slide.length > 0

	useEffect(() => {
		if (slideValido) {
			setSlideEditado(slide.map(componente => ({
				...componente,
				upload: {}
			})))
		} else {
			setSlideEditado([])
		}
	}, [slide, slideValido])

	useEffect(() => {
		if (slideValido && slideEditado.length > 0) {
			setSaveEnabled(hayCambios())
		} else {
			setSaveEnabled(false)
		}
	}, [slideEditado, slideValido])

	const hayCambios = () => {
		if (!slideValido || slideEditado.length === 0) return false

		let cambios = false
		slideEditado.forEach((componente) => {
			if (!isEmpty(componente.upload)) {
				cambios = true
			} else {
				const slideOriginal = slide.find((elem) => elem.id === componente.id)
				if (slideOriginal && componente.valor !== slideOriginal.valor) {
					cambios = true
				}
			}
		})

		return cambios
	}

	const handleChange = (valor, id) => {
		const slideCopy = [...slideEditado]
		const componente = slideCopy.find((elem) => elem.id === id)
		if (componente) {
			componente.valor = valor
			slideCopy[slideCopy.indexOf(componente)] = componente
			setSlideEditado(slideCopy)
		}
	}

	const updateNewFiles = (files, id) => {
		const slideCopy = [...slideEditado]
		const componente = slideCopy.find((elem) => elem.id === id)
		if (componente) {
			if (files.length > 0) {
				componente.upload = {
					key: componente.key,
					files: files
				}
			} else {
				componente.upload = {}
			}
			slideCopy[slideCopy.indexOf(componente)] = componente
			setSlideEditado(slideCopy)
		}
	}

	const getNombreDesdeEstructura = (tipo) => {
		const elementoEstructura = estructura?.find(elem => elem.tipo === tipo)
		return elementoEstructura ? elementoEstructura.nombre : tipo
	}

	const getJSX = (componente) => {
		let jsx = <div key={`componente-no-soportado-${componente.id}`} className="noSoportado">
			<i className="fas fa-exclamation-triangle fa-2x"></i>
		</div>

		switch (componente.tipo) {
			case 'imagen':
				jsx = (
					<div key={`slide-${componente.id}`} className="editar-imagen">
						<FileUpload
							updateFiles={(files) => updateNewFiles(files, componente.id)}
							title="Imagen para el slide*"
							accept=".jpg,.png,.jpeg"
						/>
						{isEmpty(componente.upload) && (
							<img
								className="imagen-existente"
								src={process.env.REACT_APP_API_URL + componente.valor}
								alt="Imagen seleccionada"
							/>
						)}
					</div>
				)
				break
			case 'texto-corto':
			case 'texto':
			case 'link':
				const componenteEditado = slideEditado.find(elem => elem.id === componente.id)
				const componenteOriginal = slide?.find(elem => elem.id === componente.id)

				jsx = (
					<Row key={`nuevo-componente-${componente.id}`}>
						<Col>
							<Form.Group
								className={`mb-3 ${componenteEditado && componenteOriginal && componenteEditado.valor !== componenteOriginal.valor ? 'valor-modificado' : ''}`}
								controlId={`componente-${componente.id}`}
							>
								<FormLabel>{getNombreDesdeEstructura(componente.tipo)}</FormLabel>
								<Form.Control
									value={componenteEditado ? componenteEditado.valor : ''}
									type="text"
									onChange={(e) => handleChange(e.target.value, componente.id)}
								/>
							</Form.Group>
						</Col>
					</Row>
				)
				break
		}

		return jsx
	}

	const handleCerrar = () => {
		setSlideEditado(slideEditado.map(componente => ({ ...componente, upload: {} })))
		cerrar()
	}

	const handleEditar = () => {
		// Preparar datos para enviar usando la misma estructura que armarDatosGrupoParaServer
		const datosParaEnviar = slideEditado.map(componente => ({
			...componente,
			key: componente.key // Asegurar que key esté correcto
		}))

		// Usar la función editar de Seccion.js que maneja grupos
		editar(datosParaEnviar, 'grupo')

		// Cerrar modal
		cerrar()
	}

	if (!slideValido) {
		return null
	}

	return (
		<Modal show={mostrar} onHide={handleCerrar}>
			<Modal.Header closeButton>
				<Modal.Title>Editar slide</Modal.Title>
			</Modal.Header>
			<Modal.Body className="nuevo">
				<Alert variant="info">{indicaciones}</Alert>
				{slideEditado.map((componente) => getJSX(componente))}
			</Modal.Body>
			<Modal.Footer>
				<Button variant="outline-tertiary" onClick={handleCerrar}>
					Cancelar
				</Button>
				<Button variant="primary" onClick={handleEditar} disabled={!saveEnabled}>
					Guardar
				</Button>
			</Modal.Footer>
		</Modal>
	)
}

export default EditarSlide